import api from '../Api';

/**
 * Get all ad placements
 * @returns {Promise} Promise resolving to array of ad placements
 */
export const getAllAdPlacements = async () => {
  try {
    const response = await api.get('/ad-placements');
    return response.data;
  } catch (error) {
    console.error('Error fetching ad placements:', error);
    throw error;
  }
};

/**
 * Get a specific ad placement by ID
 * @param {string} id - The ID of the ad placement
 * @returns {Promise} Promise resolving to an ad placement object
 */
export const getAdPlacementById = async id => {
  try {
    const response = await api.get(`/ad-placements/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ad placement with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Create a new ad placement
 * @param {Object} adPlacementData - The ad placement data to create
 * @returns {Promise} Promise resolving to the created ad placement
 */
export const createAdPlacement = async adPlacementData => {
  try {
    const response = await api.post('/ad-placements', adPlacementData);
    return response.data;
  } catch (error) {
    console.error('Error creating ad placement:', error);
    throw error;
  }
};

/**
 * Update an existing ad placement
 * @param {string} id - The ID of the ad placement to update
 * @param {Object} adPlacementData - The updated ad placement data
 * @returns {Promise} Promise resolving to the updated ad placement
 */
export const updateAdPlacement = async (id, adPlacementData) => {
  try {
    const response = await api.patch(`/ad-placements/${id}`, adPlacementData);
    return response.data;
  } catch (error) {
    console.error(`Error updating ad placement with ID ${id}:`, error);
    throw error;
  }
};

/**
 * Delete an ad placement
 * @param {string} id - The ID of the ad placement to delete
 * @returns {Promise} Promise resolving to the deletion result
 */
export const deleteAdPlacement = async id => {
  try {
    const response = await api.delete(`/ad-placements/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting ad placement with ID ${id}:`, error);
    throw error;
  }
};
